import { FC, useContext } from "react";
import { SidebarContext } from "../../../../../contexts/SidebarContext";
import SearchBox from "../../../../../layouts/SidebarLayout/Header/SearchBox";
import DataTable from "../../../../../shared/components/dataTable";
import useQuery from "../../../../../shared/components/hooks/useQuery";
import Loader from "../../../../../shared/components/loader/linearProgress";
import NoPermissionContent from "../../../../../shared/components/noPermissionBanner";
import { TableViewContainer } from "../../../../../shared/components/tableViewContainer";
import { formatAmountINR } from "../../../../../shared/utils/amountFormat";



const FeeList: FC = () => {

  const { payload, setPayload } = useContext(SidebarContext);

  const { loading, data, fetchData, error } = useQuery("/admin/Fees", {
    params: {
      ...payload,
    },
  });


  const feeData = data as any;

  const feeDisplayColumns = [
  "class", "totalFee", "academicYear"
];

  const titleBarNode = <SearchBox />;
 const renderFeeCell = (row: any, col: string) => {
  switch (col) {
    case "class":
      return row?.description ?? "-"; 
    case "totalFee":
      return formatAmountINR(row?.totalFee)
    case "academicYear":
      return row?.academicYear?.name ?? "-";
    default:
      return row[col] ?? "-";
  }
};


  const titleBar = { 
    title: "Fee Structure",
    headerTitle: "Fees Setup",
    titleBarNodes: (feeData?.totalItems || payload.search) && titleBarNode,
    subHeading: "",
    rowCount: feeData?.totalItems,
  }

  return (
    <TableViewContainer titleBar={titleBar}>
      {loading && <Loader />}
      {(error as any)?.statusCode === 403 && <NoPermissionContent />}
      {!loading && !error && (
        <DataTable
          entityName="Fees"
          data={feeData?.items ?? []}
          displayColumns={feeDisplayColumns}
          linkColumn="Class"
          linkUrl="/fees/fee-structure"
          pagination={{ take: payload.take || 10, skip: payload.skip || 0 }}
          setPagination={setPayload}
          totalItems={feeData?.totalItems || 0}
          refetchFunction={fetchData}
          renderCell={renderFeeCell}
        />
      )}
    </TableViewContainer>
  );
};

export default FeeList;